<template>
  <div id="main-layout">
    <!-- Navbar Component with Sidebar Toggle Button -->
    <AppNavbar />

    <!-- Sidebar (visible on mobile when toggled) -->
    <AppSidebar />

    <!-- Main Layout with Content -->
    <div class="layout">
      <main class="main-content">
        <slot /> <!-- Dynamic content like Dashboard will be displayed here -->
      </main>
    </div>
  </div>
</template>

<script>
import AppNavbar from './NavbarPage.vue';
import AppSidebar from './SidebarPage.vue';

export default {
  name: 'MainLayout',
  components: {
    AppSidebar,
    AppNavbar,
  },
};
</script>

<style scoped>
#main-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.layout {
  display: flex;
  flex: 1;
  flex-direction: row;
}

.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  margin-left: 250px; /* Offset for sidebar width on larger screens */
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
}
</style>
